import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
} from "./orderSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  createChangeHandler,
  defaultDate,
  getValueStatus,
  paramsCustomerType,
  paramsMasterAll,
  paramsStatus,
  setOptionsMaster,
  showErrorDialog,
} from "../../utility";
import { OrderTable } from "./OrderTable";
import { fetchUser, selectDataUser } from "../user/userSlice";
import Select from "react-select";
import { InputDateRange } from "../../utility/InputDateRange";
import { fetchBranch, selectBranch } from "../branch/branchSlice";

export const OrderPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataUser = useSelector(selectDataUser);

  // Filter
  const [order, setOrder] = useState("");
  const [name, setName] = useState("");
  const [customer, setCustomer] = useState("");
  const [startOrder, setStartOrder] = useState("");
  const [endOrder, setEndOrder] = useState("");
  const [startOrderDue, setStartOrderDue] = useState("");
  const [endOrderDue, setEndOrderDue] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [optionsUser, setOptionsUser] = useState([]);
  const dataBranch = useSelector(selectBranch);

  const [branch, setBranch] = useState("");
  const [optionsBranch, setOptionBranch] = useState([]);
  const handleChangeBranch = createChangeHandler(setBranch);

  const paramsFilter = {
    order_no: order,
    sales_person_name: name,
    customer_store_name: customer,
    start_order_date: startOrder,
    end_order_date: endOrder,
    start_order_due_date: startOrderDue,
    end_order_due_date: endOrderDue,
    status: status,
    customer_type: type,
    branch_code: branch,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());

      setStartOrder(defaultDate);
      setEndOrder(defaultDate);

      const params = {
        ...paramsFilter,
        start_order_date: defaultDate,
        end_order_date: defaultDate,
        pageNo: 1,
        pageSize: 10,
      };
      await dispatch(fetchUser({ ...paramsMasterAll, roles: "SALES" ,is_active: true}));

      await dispatch(fetchData(params));
      await dispatch(fetchBranch({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster(
        dataUser,
        setOptionsUser,
        "company_sales_code",
        "name_username"
      );
    }
  }, [dataUser]);
  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [dataBranch]);

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeSales = createChangeHandler(setName);
  const handleChangeStatus = createChangeHandler(setStatus);
  const handleChangeType = createChangeHandler(setType);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Orders"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Sales</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsUser}
                    value={getValueStatus(name, optionsUser)}
                    placeholder="Select ..."
                    onChange={handleChangeSales}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Order No</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={order}
                    onChange={(e) => setOrder(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Order Date</b>
                </Form.Label>

                <Col sm={6}>
                  <InputDateRange
                    setEndDate={setEndOrder}
                    setStartDate={setStartOrder}
                    endDate={endOrder}
                    startDate={startOrder}
                    CallApi={fetchData}
                    paramsFilter={paramsFilter}
                    paramsStart={"start_order_date"}
                    paramsEnd={"end_order_date"}
                    hidden={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Type</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={paramsCustomerType}
                    value={getValueStatus(type, paramsCustomerType)}
                    placeholder="Select ..."
                    onChange={handleChangeType}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={customer}
                    onChange={(e) => setCustomer(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Order Due Date</b>
                </Form.Label>

                <Col sm={6}>
                  <InputDateRange
                    setEndDate={setEndOrderDue}
                    setStartDate={setStartOrderDue}
                    endDate={endOrderDue}
                    startDate={startOrderDue}
                    CallApi={fetchData}
                    paramsFilter={paramsFilter}
                    paramsStart={"start_order_due_date"}
                    paramsEnd={"end_order_due_date"}
                    hidden={false}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Status</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={paramsStatus}
                    value={getValueStatus(status, paramsStatus)}
                    placeholder="Select ..."
                    onChange={handleChangeStatus}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Branch</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(branch, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeBranch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Col>
                {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        <OrderTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};
